import script from "./schoolDtails.vue?vue&type=script&setup=true&lang=js"
export * from "./schoolDtails.vue?vue&type=script&setup=true&lang=js"

import "./schoolDtails.vue?vue&type=style&index=0&id=2fa4c0b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa4c0b7"]])

export default __exports__